import React, { Suspense, useMemo } from 'react'
import Card from 'src/components/Card'
import CardBody from './CardBody'
import { Table } from '@imcva/reactstrap-table'
import { columns } from './columns'
import { faPlus, faFilter } from '@fortawesome/free-solid-svg-icons'
import Filters from './Filters'
import useFilterState from './Filters/useFilterState'
import { Button } from 'reactstrap'
import { usePositionStatuses } from 'src/queries'
import useToggleState from 'src/hooks/useToggleState'
import AddModal from 'src/pages/cat/positions/List/AddModal'

const List: React.FC = (props) => {
  const statuses = usePositionStatuses()
  const [isOpen, , handleToggle] = useToggleState()
  const { filterProps, queryFilters, buttonColor } = useFilterState()
  const handleOpenFilters = filterProps.toggleOpen
  const statusLabels = statuses?.map(s => String(s.name))
  const memoColumns = useMemo(() => {
    return columns(statusLabels)
  }, [statusLabels])
  return (
    <>
      <Card
        title='Positions'
        primaryAction={[
          {
            key: 'position-filters',
            tag: Button,
            icon: faFilter,
            text: 'Filter',
            onClick: handleOpenFilters,
            color: buttonColor
          },
          {
            key: 'add-position',
            icon: faPlus,
            text: 'Add Position',
            onClick: handleToggle,
            permissionKey: 'CAT_EDIT'
          }
        ]}
      >
        <Suspense>
          <Filters {...filterProps} />
        </Suspense>
        <Suspense fallback={<Table options={{ data: [], columns: memoColumns }} suspend={3} />}>
          <CardBody columns={memoColumns} queryFilters={queryFilters} />
        </Suspense>
      </Card>
      <AddModal isOpen={isOpen} toggle={handleToggle} />
    </>
  )
}

export default List
